module.exports = __webpack_public_path__ + "assets/a3634823b2e013ae2e208b657b7b1a8b.png";